import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { CREATOR_VIDEO_FEED } from "../constants/urls";
import GlipHeader from "../components/mobile/GlipHeader";
import SwiperCore, { Pagination } from "swiper/core";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import map from '../assets/map_image.svg';
import valo from '../assets/valo_image.png';

// install Swiper modules
SwiperCore.use([Pagination]);

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
`;

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
`;

const VideoDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 16px;
`;

const VideoDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  max-width: 60%;
`;

const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  z-index: 1;
`;

const UserName = styled.div`
  font-size: 20px;
  font-weight: 600;
  font-family: "Poppins";
  padding-bottom: 8px;
  z-index: 1;
`;

const Caption = styled.div`
  font-weight: 500;
  font-size: 16px;
  font-family: "Inter";
`;

const BlueBanner = styled.a`
  background: linear-gradient(254.06deg, #59c5e8 -33.43%, #5a8ef1 113.89%);
  font-family: "Inter";
  padding: 10px 16px;
  margin: 16px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

const VideoHolder = styled.video`
  transform: scale(2.5);
  display: flex;
  height: 50vh;
`;

const Container = styled.div`
  padding: 12px 120px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100vh;
`;

const ProfileBox = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: row;
  background: rgba(21, 21, 29, 1);
  border-radius: 16px;
  margin-bottom: 18px;
  flex-direction: column;
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(21, 21, 29, 1)",
    borderWidth: 0,
    padding: "62px 62px",
    height: "214px",
    width: "340px",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
    alignItems: "center",
  },
};

const MapImage = styled.img`
    width: 100%;
`;

const Red = styled.span`
    color: rgba(255, 96, 96, 1);
    text-transform: uppercase;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    margin-left: 6px;
`;

const Green = styled.span`
    color: rgba(75, 179, 75, 1);
    text-transform: uppercase;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    margin-left: 6px;
`;

const Score = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
`;

const Date = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: rgba(122, 127, 158, 1);
`;

const Banner = styled.div`
    margin-top: 12px;
    background: #141624;
    /* Light / Image Border */

    border: 0.33px solid rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    background: rgba(20, 22, 36, 1);
    padding: 12px 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

`;

const BannerHeading = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;    
`;

const RedCard = styled.div`
    background: linear-gradient(179.2deg, rgba(252, 70, 83, 0.2) 0.68%, rgba(252, 70, 83, 0) 99.32%);
    padding: 16px;
    display: flex;
    flex-direction: row;
    min-height: 114px;
    border-top: 1px solid #FC4653;
    justify-content: space-between;
`;

const Card = styled.div`
    background: linear-gradient(180deg, rgba(20, 22, 36, 0.5) 0%, rgba(20, 22, 36, 0) 100%);
    padding: 16px;
    display: flex;
    flex-direction: row;
    min-height: 114px;
    border-top: 1px solid #1C1F33;
    justify-content: space-between;
`;

const CardHeading = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 125%;   
`;

const CardSubheading = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.2px;
    color: #7A7F9E;  
`;

const CardDetailsWrapper = styled.div`
    display: flex;
    flex-direction : column;    
`;


const CardUsername = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.2px;
    color: #FC4653;   
    margin-top: 20px;
`;

const CardImage = styled.img``;

export default function MatchSummary(props) {
  const [data, dataSet] = useState();

  const history = useHistory();
  const location = useLocation();
  console.log(history, location)
  const { matchId } = useParams();

  useEffect(() => {
    async function fetchMyAPI() {
      let response = await fetch(CREATOR_VIDEO_FEED + profileId);
      response = await response.json();
      console.log(response);

      const videos = [];
    //   videos.push(response.data.videos);
      response.data.videos.map((item) => videos.push(item));
      videosSet(videos);
      usersSet(response.data.profiles);
      videoSet(response.data.videos);
      dataSet(response.data);
    }

    // fetchMyAPI();
  }, []);

//   useEffect(() => {
//     if (data) {
//       var vid = document.getElementsByClassName(`video-0`)[0];
//       vid.play();
//     }
//   }, [data]);

//   if (!data) {
//     return <></>;
//   }
 ;

 const openScorecard = () => {
    history.push('/scorecard')
 };

 const card_list = [1,1,1,1,1,1].map((item, index) => {
     return (
        <Card key={`${index}-cards`}>
            <CardDetailsWrapper>
                <CardHeading>The Game MVP</CardHeading>
                <CardSubheading>24 Kills, 16 Deaths</CardSubheading>
                <CardUsername>parth</CardUsername>
            </CardDetailsWrapper>
            <CardImage src={valo}></CardImage>
        </Card>
     );
 })

  return (
    <>
      <Mobile>
        <GlipHeader title={'Match Summary'}/>
        <MapImage src={map} />

        <div style={{ padding: '10px 20px' }}>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <Score>16-9</Score>
                <Red>Red won</Red>            
            </div>
            <Date>January 24, 2021</Date>
        </div>

        <Banner onClick={() => openScorecard()}>
            <BannerHeading>Scorecard</BannerHeading>
            <span style={{color: '#5F6382'}}>></span>
        </Banner>
        <Banner style={{borderTop: '6px solid #0E0F18', marginBottom: 4}}>
            <BannerHeading>Awards</BannerHeading>
        </Banner>

        <RedCard>
            <CardDetailsWrapper>
                <CardHeading>The Game MVP</CardHeading>
                <CardSubheading>24 Kills, 16 Deaths</CardSubheading>
                <CardUsername>parth</CardUsername>
            </CardDetailsWrapper>
        </RedCard>

        {card_list}

      </Mobile>
    </>
  );
}

// module.exports = VideoPage;
